
		letterAdjust.scale = 0.8;
		var font = {
			"0": "M354 -182v1593l228 227h573l225 -227v-1593l-225 -228h-573zM715 -49h307v1327h-307v-1327z",
			"1": "M356 -49h172v1198h-172v203l199 286h334v-1687h172v-361h-705v361z",
			"2": "M358 317l668 510v451h-307v-129h-361v262l228 227h573l225 -227v-760l-665 -512v-188h665v-361h-1026v727z",
			"3": "M354 80h361v-129h307v483h-315v361h315v483h-307v-129h-361v262l228 227h573l225 -227v-715l-82 -82l82 -82v-714l-225 -228h-573l-228 228v262z",
			"4": "M272 186v424l643 1028h373v-1091h172v-361h-172v-235h172v-361h-704v361h172v235h-656zM657 547h271v434z",
			"5": "M360 80h361v-129h307v483h-668v1204h1026v-360h-665v-483h440l225 -228v-749l-225 -228h-573l-228 228v262z",
			"6": "M354 -182v1593l228 227h573l225 -227v-262h-358v129h-307v-483h440l225 -228v-749l-225 -228h-573zM715 -49h307v483h-307v-483z",
			"7": "M336 1149v489h1026v-340l-424 -1708h-371l420 1688h-291v-129h-360z",
			"8": "M354 -182v714l82 82l-82 82v715l228 227h573l225 -227v-715l-82 -82l82 -82v-714l-225 -228h-573zM715 -49h307v483h-307v-483zM715 795h307v483h-307v-483z",
			"9": "M354 80h361v-129h307v483h-440l-228 228v749l228 227h573l225 -227v-1593l-225 -228h-573l-228 228v262zM715 795h307v483h-307v-483z",
			"A": "M145 -410l478 2048h235l477 -2048h-254l-114 484h-453l-113 -484h-256zM565 295h350l-174 752z",
			"B": "M244 -410v2048h540q223 0 381 -146t158 -353v-101q0 -115 -53 -216t-148 -171q94 -72 147.5 -173t53.5 -216v-172q0 -207 -157.5 -353.5t-381.5 -146.5h-540zM520 -188h264q109 0 186 71.5t77 171.5v242q0 100 -77 172t-186 72h-264v-729zM520 762h264q109 0 186 71 t77 171v170q0 100 -77 171.5t-186 71.5h-264v-655z",
			"C": "M217 78v1073q0 201 143.5 344t345 143t345 -143t143.5 -344h-252v33q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-1139q0 -98 69.5 -168t168 -70t168 70t69.5 168v33h252q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5z",
			"D": "M244 -410v2048h499q207 0 352.5 -146t145.5 -353v-1049q0 -207 -145.5 -353.5t-352.5 -146.5h-499zM500 -188h243q100 0 172 71.5t72 171.5v1119q0 100 -71.5 171.5t-172.5 71.5h-243v-1605z",
			"E": "M244 -410v2048h790v-221h-534v-692h487v-221h-487v-692h534v-222h-790z",
			"F": "M244 -410v2048h790v-221h-534v-692h487v-221h-487v-914h-256z",
			"G": "M217 78v1073q0 201 143.5 344t345 143t345 -143t143.5 -344h-252v33q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-1139q0 -98 69.5 -168t168 -70t168 70t69.5 168v461h-237v217h489v-645q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5z",
			"H": "M244 -410v2048h256v-913h487v913h254v-2048h-254v914h-487v-914h-256z",
			"I": "M244 -410v2048h256v-2048h-256z",
			"J": "M129 -258l168 158q74 -90 188 -90q98 0 169 70.5t71 168.5v1589h254v-1554q0 -205 -144.5 -349.5t-349.5 -144.5q-211 0 -356 152z",
			"K": "M244 -410v2048h256v-933l456 933h287l-418 -850l473 -1198h-274l-350 887l-174 -354v-533h-256z",
			"L": "M244 -410v2048h256v-1826h534v-222h-790z",
			"M": "M244 -410v2048h233l412 -1134l414 1134h233v-2048h-256v1356l-311 -856h-158l-311 856v-1356h-256z",
			"N": "M244 -410v2048h229l514 -1364v1364h254v-2048h-229l-512 1364v-1364h-256z",
			"O": "M217 78v1073q0 201 143.5 344t345 143t345 -143t143.5 -344v-1073q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5zM467 45q0 -98 69.5 -168t168 -70t168 70t69.5 168v1139q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-1139z",
			"P": "M244 -410v2048h540q223 0 381 -146t158 -353v-199q0 -205 -157.5 -351.5t-381.5 -146.5h-264v-852h-276zM520 664h264q109 0 186 70.5t77 172.5v267q0 100 -77 171.5t-186 71.5h-264v-753z",
			"Q": "M217 78v1071q0 203 143.5 346t345 143t345 -143t143.5 -346v-1071q0 -145 -78 -266l154 -129l-117 -140l-162 138q-127 -92 -284 -93q-203 0 -346.5 143.5t-143.5 346.5zM467 43q0 -98 69.5 -168t170.5 -70q55 0 104 25l-133 115l115 137l137 -117q14 39 14 78v1141 q0 98 -69.5 167.5t-169 69.5t-169 -69.5t-69.5 -167.5v-1141z",
			"R": "M244 -410v2048h499q207 0 353.5 -146t146.5 -353v-197q0 -154 -84 -277.5t-219 -181.5l303 -893h-270l-289 852h-184v-852h-256zM500 664h243q100 0 172 70.5t72 172.5h-2v267q0 100 -70.5 171.5t-171.5 71.5h-243v-753z",
			"S": "M217 78v43h250v-76q0 -98 69.5 -168t168 -70t169 70t70.5 168v248q0 49 -32.5 97t-77.5 67l-392 161q-92 39 -158.5 130.5t-66.5 183.5v219q0 201 143.5 344t345 143t345 -143t143.5 -344v-43h-252v76q0 98 -69.5 167.5t-168 69.5t-168 -69.5t-69.5 -167.5v-187 q0 -49 32.5 -97t78.5 -66l389 -162q94 -37 160.5 -136.5t66.5 -199.5v-258q0 -201 -143.5 -344.5t-345 -143.5t-345 143.5t-143.5 344.5z",
			"T": "M199 1417v221h997v-221h-371v-1827h-256v1827h-370z",
			"U": "M236 84v1554h253v-1589q0 -98 70 -168.5t170 -70.5t170 70.5t70 168.5v1589h254v-1554q0 -205 -144.5 -349.5t-349.5 -144.5t-349 144.5t-144 349.5z",
			"V": "M186 1638h263l307 -1421l307 1421h262l-442 -2048h-254z",
			"W": "M195 1638h260l227 -1323l254 1323h369l254 -1323l229 1323h260l-354 -2048h-256l-318 1649l-315 -1649h-256z",
			"X": "M213 -410l371 1024l-371 1024h256l244 -671l241 671h258l-372 -1024l372 -1024h-258l-241 672l-244 -672h-256z",
			"Y": "M180 1638h269l235 -766l238 766h268l-377 -1218v-830h-256v830z",
			"Z": "M233 -188l558 1605h-558v221h791v-221l-557 -1605h557v-222h-791v222z"
		};
		// Colors are in order like this...  home: [ inside, outline, outline2, outline3 ]
		var font_size = 21,
			tracking = 2,
			panel_Hor_Adjustment = 0,
			font_Top_Adjustment = -4.5,
			small_Caps_Adjustment = {
				vertical: -50,
				horizontal: 0,
				scale_width: 0,
				scale_height: 0,
			},
			colors = {
				characters: {
					home: [
						"#FFFFFF", // white
					],
					away: [
						"#091F44", // blue
					]
				},
				numbers: {
					home: [
						"#FFFFFF", // white
						"#091F44", // blue
						"#DA1E3F", // red
					],
					away: [
						"#091F44", // blue
						"#FFFFFF", // white
						"#DA1E3F", // red
					]
				}
			},
			outlines = {
				characters: {
					width: 0
				},
				numbers: {
					width: 2.5
				}
			},
			special_Character_Adjustments = {
				period: {
					vertical: -4.5, // this moves it up from the bottom
					horizontal: 3,
					scale_width: 12.5,
					scale_height: 12.5,
				},
				hyphen: {
					vertical: -6,
					horizontal: -5.5,
					scale_width: 0,
					scale_height: -3,
				},
				apostrophe: {
					vertical: 0.25, // this is backwards
					horizontal: -1,
					scale_width: 0,
					scale_height: 0,
				}
			},
			number_Adjustments = {
				top: 19,
				left: -10,
				width: 81,
				height: 61,
				middle_Space: 5,
			};